<template>
    <Grid/>
</template>

<script>
    import Grid from './../components/Area/POA/components/Evaluation/Middle/Grid'

    export default {
        components: {
            Grid,
        }
    }
</script>